export default __webpack_public_path__ + "static/media/uniforms.a2e30cf0.png";